import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"
import G from "../../utils/SvgGroup"

const SkypeIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-5.6 0 27 15"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <Path d="m0 0h16v16h-16z" />
      </clipPath>
      <G clip-path="url(#a)">
        <Path
          d="m8.03532 12.8153c-2.65789 0-3.87224-1.354-3.87224-2.3471-.00036-.2369.09687-.4635.26882-.62645.17194-.16298.40342-.24794.63997-.2349 1.13796 0 .8403 1.70695 2.96345 1.70695 1.08528 0 1.72275-.6533 1.72275-1.267 0-.36883-.21073-.79029-.92723-.95888l-2.37076-.59796c-1.90451-.48469-2.23641-1.54363-2.23641-2.52617 0-2.03886 1.86499-2.77643 3.64043-2.77643 1.63582 0 3.5798.90353 3.5798 2.12578 0 .52684-.4399.8087-.9509.8087-.972 0-.80869-1.36451-2.76325-1.36451-.97201 0-1.48304.45572-1.48304 1.09319s.75601.85347 1.41982.99835l1.7491.39513c1.91767.432 2.42867 1.55679 2.42867 2.63417 0 1.65693-1.2828 2.93713-3.81162 2.93713zm7.33878-3.50611c.076-.43491.1139-.8756.1133-1.31709.0093-2.21768-.9651-4.32535-2.6606-5.75487-1.6955-1.429515-3.93753-2.03374-6.12174-1.649798-.67135-.38653-1.43277-.58915233-2.20744-.587421-1.59009.00971354-3.05578.861921-3.850824 2.239019-.795043 1.3771-.800186 3.07253-.013513 4.45442-.438958 2.41194.329966 4.88605 2.058747 6.62425 1.72878 1.7383 4.19866 2.5207 6.61296 2.0949.67053.3862 1.43101.5888 2.20481.5874 1.5893-.0102 3.0541-.8621 3.8489-2.2384.7949-1.3762.8008-3.0707.0154-4.45241z"
          fill={color}
        />
      </G>
    </Svg>
  )
}

export default SkypeIconSvg
